import React from 'react';
import ActionButton from '../buttons/ActionButton';
import { faPlay } from '@fortawesome/free-solid-svg-icons';
import './GameOver.css';

interface HighScore {
  username?: string;
  score: number;
}

interface GameScore {
  global_high_score: HighScore | null;
  user_high_score: HighScore | null;
  user_rank: number | null;
}

interface GameOverProps {
  score: number;
  gameScore?: GameScore;
  onPlayAgain: () => void;
  isHighScore: boolean;
}

const GameOver: React.FC<GameOverProps> = ({
  score,
  gameScore,
  onPlayAgain,
  isHighScore,
}) => {
  const globalHighScore = gameScore?.global_high_score?.score ?? 0;
  const userHighScore = gameScore?.user_high_score?.score ?? 0;
  const userRank = gameScore?.user_rank ?? 0;

  return (
    <div className="game-over">
      <div className="game-over-content">
        <span className="label-large">Game Over!</span>
        <span className="label-large score">Final score: {score}</span>

        {gameScore && (
          <div className="game-over-stats">
            {isHighScore ? (
              <div className="new-high-score">
                <span className="label-large">New High Score! 🎉</span>
                <span className="label-normal">
                  Global high score: {globalHighScore}
                </span>
              </div>
            ) : (
              <>
                <span className="label-normal">
                  Global high score: {globalHighScore}
                  {gameScore.global_high_score?.username && (
                    <span className="username"></span>
                  )}
                </span>
                <span className="label-normal">
                  My high score: {userHighScore}
                </span>
                {userRank > 0 && (
                  <span className="label-normal">My rank: #{userRank}</span>
                )}
              </>
            )}
          </div>
        )}

        <ActionButton
          icon={faPlay}
          label="Play Again"
          type="go"
          onClick={onPlayAgain}
        />
      </div>
    </div>
  );
};

export default GameOver;
